export default (props, vars) => !vars?.['useform1']?.['formState'].isValid;
